import { ValuationStepData } from '@/interfaces/valuation/ValuationData'
import { Message } from '@/interfaces/app/Message'

export default abstract class ValuationStepValidator {
  public isValid: boolean = false
  public errors: { [inputName: string]: string | [] } = {}
  public abstract validate(data: ValuationStepData): Message[]

  /**
   * Validates whether enum object contains field
   *
   * @param {object} enumObject TypeScript enumeration to check
   * @param {any} field Data to look for
   *
   * @return {boolean}
   */
  protected enumContains(enumObject: object, field: any): boolean {
    return Object.values(enumObject).includes(field)
  }
}
